<template ref="mmm">
    <div class="body" ref="body" :data-r="rank">
				<template v-if="!isOnline">
					<a v-if="loginButton.length > 1" :href="loginButtonLink" :class="classes" style=" display: inline-block;">{{loginButton}}</a>
					<a v-if="registrationButton.length > 1" :href="registrationButtonLink" :class="classes" style="margin-left: 5px; display: inline-block;">{{registrationButton}}</a>
				</template>
				<template v-else>
					<upload-img :no-square="true"
											field="avatar2"
											upload-avatar-from-vuex
											:user-id="user_id"
											:account-id="aid"
											img-format="png"
											v-model="showUpload"
											ki="0"
											v-bind:lang-type="(locale||'en-US').toString().substring(0,2)"></upload-img>
					<mlm-popover trigger="click" :options="{placement: 'auto'}"
											ref="mlm_popover">
							<div slot="reference" class="user-account-btn">
									<span id="dropdown_user">
											<span id="id_b_p" class="icon-down" style="backgrounf: #008fe2;" v-bind:class="loading? 'disabled' : ''" ref="ex1">
													<font-awesome-icon icon="angle-down" style="color: #000;"></font-awesome-icon>
											</span>
									</span>
									<div title="My Account" class="user-profile a-span"
											aria-expanded="true">
										<div class="display-inline" v-if="loading"
													style="margin-right: 8px; float: left; width: 28px; height: 28px;"><span
														style="margin-right: 0" class="loading"></span></div>
										<img alt="Profile image" v-else class="mini-image"
													v-bind:src="fields['avatar_id'].value.raw != null && fields['avatar_id'].value.raw.imageUrl ? fields['avatar_id'].value.raw.imageUrl : (!fields['gender'].value.raw ? emptyPerson : (fields['gender'].value.presentable.toString().toLowerCase() === 'female' ? emptyPersonFemale : emptyPersonMale))"
													width="28" height="28">
										<span id="name_user">
												<span class="span-name" :style="btnStyles" v-if="loading">{{ $t("message.loading") }}</span>
												<span class="span-name" :style="btnStyles" v-else>{{fields['firstname'].value.presentable+' '+fields['lastname'].value.presentable}}</span>
										</span>
									</div>
							</div>
							<div slot="body">
									<slot></slot>
									<div v-if="!loading">
											<div class="box-sm">
													<div class="divider"></div>
													<div class="pad5A button-pane button-pane-alt text-center">
															<a href="#" role="button" @click="logout"
																class="btn display-block font-normal btn-danger">{{ $t("message.logout") }}</a>
													</div>
											</div>
									</div>
							</div>

					</mlm-popover>
				</template>
    </div>
</template>
<script>
    import mlmPopover from '../../nested_components/mlm_popover/Popover'
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
    import {faAngleDown, faCopy} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
    import uploadImg from '../../nested_components/upload_image/upload-img'
    import Layer0 from '../../extend_classes/Layer0'
    library.add(faAngleDown, faCopy);


    const i18n = new window.VueI18n({
        locale: 'en-US', // set locale
        fallbackLocale: 'en-US',

        messages: {
            "en-US": {
                "message": {
                    "logout": "Logout",
                    "change": "change",
                    "loading": "Loading"
                }
            }
        }

    });
    export default {
        name: 'user-menu',
        i18n: i18n,
        extends: Layer0,
        components: {
            FontAwesomeIcon,
            mlmPopover,
            uploadImg
        },
        data: function () {
            return {
                user_id: null,
                showUpload: false,
                fields: null,
                allProps: [],
                bottomProps: [],
                tp: ["firstname", "lastname", "avatar_id", "gender", "email"],
                loc_name: 'VUserPop',
                visibleProps: [],
								isOnline: false,
            }
        },
        props: {
            nameColor: {
              default: '#FFF',
              required: false,
              type: String
            },
            accountId: {
                required: false,
                type: Number
            },
            accountProperties: {
                default: '[]',
                required: false,
                type: String
            },
            loginButton: {
                default: '',
                required: false,
                type: String
            },
            loginButtonLink: {
                default: '',
                required: false,
                type: String
            },
            registrationButton: {
                default: '',
                required: false,
                type: String
            },
            registrationButtonLink: {
                default: '',
                required: false,
                type: String
            },
            classes: {
                default: 'btn font-normal btn-success',
                required: false,
                type: String
            },
            ...Layer0.props
        },
        computed: {
            lastPageLowItems() {
                return (this.perPage * this.currentPage) < this.totalRows;
            },
            btnStyles() {
              return {
                "color": this.nameColor,
              };
            }
        },
				mounted() {
            if (!window.MLMSoftUICore)
                window.addEventListener('singletonCreated', () => {
                    this.store = window.MLMSoftUICore.instance.getStore();
                });
            else {
                this.store = window.MLMSoftUICore.instance.getStore();
            }
            // if(!this.store?.state?.isLoggedIn)
                this.getInfo()
        },
				methods: {
            clip(refId) {
                function selectText(element) {
                    let range;
                    if (document.selection) {
                        // IE
                        range = document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    } else if (window.getSelection) {
                        range = document.createRange();
                        range.selectNode(element);
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(range);
                    }
                }
                /* Get the text field */
                let copyText = this.$refs[refId][0];
                selectText(copyText);
                /* Copy the text inside the text field */
                document.execCommand("copy");
            },
            logout(e) {
                e.preventDefault();
                localStorage.removeItem('user-token');
                localStorage.removeItem('user-refresh-token');
                localStorage.removeItem('accessTokenApi3');
                localStorage.removeItem('refreshTokenApi3');
                document.cookie = 'tkns'+'="";-1; path=/';
                location.reload()
            },
            getAp() {
                let at;
                try {
                    at = JSON.parse(this.accountProperties);
                    if (!Array.isArray(at))
                        at = [];
                } catch (e) {
                    at = [];
                }
                if (at.length)
                    this.allProps = at.map((p) => p.replace(/^.*\./g,''));
                this.visibleProps = this.allProps.map((p) => p.replace(/^.*\./g,''))
            },
            async getInfo() {
                // this.loading = true;
                this.aid = this.accountId;
                if (!this.aid) {
                    this.aid = await this.store?.dispatch('getAccountId');
                }
                if (!this.aid) {
									this.isOnline = false;
                  // this.loading = false;
									return false;
								} else {
                  this.isOnline = true;
                  this.store.dispatch('setOnlineStatus', true);
                }


                let propsQuery = ''
                let position   = null

                await this.store.dispatch('requestApi3', {
                  path: `account/${this.aid}/position${propsQuery}`,
                  method: 'get'
                }).then(response => {
                  position = response.data.payload 
                }).catch((e) => {
                  console.log(e)
                })

                let profile = null

                await this.store.dispatch('requestApi3', {
                    path: `account/${this.aid}/profile`,
                    method: 'get'
                    }).then(response => {
                  profile = response.data.payload 
                }).catch((e) => {
                  console.log(e)
                })

                const properties = new Set(this.allProps.concat(this.tp));
                this.bottomProps = this.allProps;
                this.allProps = [...properties];

                this.buildFields(position, profile);
                this.loading = false;
            },
            isVisibleProp(propName) {
                return this.visibleProps.includes(propName)
            },
            deepFind(obj, path) {
                let current = obj, i;
                if(obj) {
                  if (path.length) {
                    const tmp = path.split('.');
                    for (i = 0; i < tmp.length; ++i) {
                      if (current[tmp[i]] == null) {
                        return undefined;
                      } else {
                        current = current[tmp[i]];
                      }
                    }
                  }
                  return current;
                } else {
                  return '';
                }

            },
            buildFields(position, profile) {
                this.fields = null;
                let tempFields = [];
                let tempFieldsAddition = [];

                // if(r.get(this.aid + '.s.user_id')) {
                //     this.user_id = r.get(this.aid + '.s.user_id').obj_val.value;
                // }

                if (position[0].parentPosition) {
                    tempFields.push(['parent_account_id', { title: 'Parent Account Id', value: {presentable: position[0].parentPosition.accountId}, label: ''}]);
                }

                this.allProps.forEach((value) => {
                    let _value = value.replace(/^.*\./g,'')

                    position[0].properties.forEach((p) => {
                        if (_value == p.alias) {
                            tempFields.push([_value, p]);

                            if(_value !== 'avatar_id' && _value !== 'sponsor_info' && _value !== 'gender') {
                                tempFieldsAddition.push(p);
                            }
                        }
                    })

                    profile.forEach((p) => {
                        if (_value == p.alias) {
                            tempFields.push([_value, p]);

                            if(_value !== 'avatar_id' && _value !== 'sponsor_info' && _value !== 'gender') {
                                tempFieldsAddition.push(p);
                            }
                        } 
                    })
                });
    

                let ggg = {};
                tempFields.forEach((value) => {
                    ggg[value[0]] = value[1];
                });

                this.fields = ggg;

                if(!this.fields['gender']) {
                    this.fields['gender'] = { value: {presentable: ''}, label: ''}
                }
                if(!this.fields['avatar_id']) {
                  this.fields['avatar_id'] = { value: {presentable: '', raw: {imageUrl:'', thumbUrl:''}}, label: '' }
                }
                if(!this.fields['email']) {
                  this.fields['email'] = { value: {presentable: ''}, label: ''}
                }
                if(!this.fields['firstname']) {
                  this.fields['firstname'] = { value: {presentable: ''}, label: '' }
                }
                if(!this.fields['lastname']) {
                  this.fields['lastname'] = { value: {presentable: ''}, label: ''}
                }
            }
        }
    }
</script>
<style scoped>
    @import '~bootstrap/dist/css/bootstrap.min.css';
    @import '~bootstrap/dist/css/bootstrap-grid.min.css';
    @import '~bootstrap-vue/dist/bootstrap-vue.min.css';
    @import "./../../styles/monarch/helpers/boilerplate.css";
    @import "./../../styles/monarch/themes/admin/color-schemes/default.css";
    @import "./../../styles/monarch/themes/admin/layout.css";
    @import "./../../styles/monarch/widgets/dropdown/dropdown.css";
    @import "./../../styles/monarch/helpers/utils.css";
    @import "./../../styles/monarch/themes/components/default.css";
    @import "./../../styles/monarch/elements/content-box.css";
    @import "./../../styles/monarch/elements/dashboard-box.css";
    @import "./../../styles/monarch/snippets/login-box.css";
    @import "./../../styles/monarch/helpers/spacing.css";
    @import "./../../styles/monarch/helpers/border-radius.css";
    @import "./../../styles/monarch/helpers/colors.css";
    @import "./assets/user-pop.css";
</style>
